import React from "react";
import Styles from "./TextInput.module.css";
import { IconButton, Tooltip } from "@mui/material";
import { ReactComponent as InfoIcon } from "../../../assets/images/info.svg";

const TextInput = ({
  heading,
  isInteger,
  allowDecimal = false,
  allowNegative = true,
  example,
  value,
  onChange,
  readOnly = false,
  type = "text",
  height = 40,
  error,
  gap = 8,
  disabled = false,
  info,
  width,
  inputStyle,
  min,
  max,
  showErrorMessage = true,
}) => {
  return (
    <div
      className={Styles.inputTextContainer}
      style={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        gap: `${gap}px`,
      }}
    >
      {heading || info ? (
        <div className={Styles.inputLabelContainer}>
          {heading && <div className={Styles.inputLabel}>{heading}</div>}{" "}
          {info && (
            <Tooltip
              title={
                <span style={{ whiteSpace: "pre-line" }}>{info}</span> || ""
              }
            >
              <IconButton>
                <InfoIcon />
              </IconButton>
            </Tooltip>
          )}
        </div>
      ) : null}

      <div
        className={`${Styles.inputContainer} ${error ? Styles.inputContainerError : ""}`}
  style={{
    height: `${height}px`,
    width: width ? width : "100%",
    backgroundColor: disabled ? "#e9e9e9" : "white",
  }}
      >
        <input
          {...(min !== undefined ? { min } : {})}
          {...(max !== undefined ? { max } : {})}
          style={inputStyle}
          disabled={disabled}
          type={type}
          className={Styles.textInput}
          placeholder={example}
          value={value}
          onChange={(e) => {
            let val = e.target.value;
            if (type === "number") {
              if (isInteger) {
                // Only integers allowed
                const intRegex = allowNegative ? /^-?\d*$/ : /^\d*$/;
                if (val === "" || intRegex.test(val)) {
                  onChange(val);
                }
              } else if (allowDecimal) {
                // Allow decimals up to 3 decimal places
                const decimalRegex = allowNegative
                  ? /^-?\d*\.?\d{0,3}$/
                  : /^\d*\.?\d{0,3}$/;
                if (val === "" || decimalRegex.test(val)) {
                  onChange(val);
                }
              } else {
                // No decimals allowed, only whole numbers
                const wholeRegex = allowNegative ? /^-?\d*$/ : /^\d*$/;
                if (val === "" || wholeRegex.test(val)) {
                  onChange(val);
                }
              }
            } else {
              onChange(val);
            }
          }}
          readOnly={readOnly}
        />
      </div>
      {error && showErrorMessage && (
        <div
          className={Styles.errorHeading}
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            fontSize: "10px",

            marginTop: "2px",
          }}
        >
          {error}
        </div>
      )}
    </div>
  );
};

export default TextInput;
